import React, { useEffect, useState } from 'react';
import Router from './config/Router';
import { Provider, useSelector } from "react-redux"
import store from "./store"
import './css/Ecoideas.css';
import './css/Icon.css';
import './css/keyFrames.css';
import './css/App.css';
import './css/Img.css';
import './css/Text.css';
import './css/Inputs.css';
import './css/svg.css';
import 'react-calendar/dist/Calendar.css';
import './css/Dropzone.css'
import './css/Landings.css'
import './admin/css/Admin.css'
import './css/Layout.css';
import '../node_modules/react-gif-player/dist/gifplayer.css'
import './css/Docs.css'
import 'animate.css';
import universe from '../src/img/logo_final_png.png'
import socketLogic from './sockets/sockets';
import useUnload from './containers/useUnload';
import localStorage from './utils/hooks/useLocalStorage';
//import { Console, Hook, Unhook } from 'console-feed'
import { useHistory } from 'react-router-dom';
import Input from './utils/components/Input/Input';
import InputTextArea from './utils/components/InputTextArea/InputTextArea';
//import $ from 'jquery';

//estado de conexión al servidor

const App = () => {
  // window.console.logs.push(Array.from(arguments));
  const [logs, setLogs] = useState([])

 /*  useEffect(() => {
    Hook(
      window.console,
      (log) => {
        if (log.data.length > 0) {
          setLogs((currLogs) => [...currLogs, log])
        }

      },
      false
    )
    return () => Unhook(window.console)
  }, []) */

  useEffect(() => {


    socketLogic.checkStatus()

    return () => {
      socketLogic.userDisconnect(localStorage().getItem('idProfile'))
    }
  }, [])


  return (
    <Provider store={store}>
      <ErrorBoundary logs={logs}>
        <Router></Router>
      </ErrorBoundary>
    </Provider>
  )


}

export default App;

class ErrorBoundary extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null,email:null,description:null};
   

  }

  componentDidCatch(error, errorInfo) {


    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path


      return (
        <div>
          <h2>Ocurrió un error.</h2>
          <Input  placeholder='Correo electrónico' onChange={e=>this.setState({email:e.target.value})}/>
          <InputTextArea placeholder={"Describa que esta haciendo cuando sucedió el error"} type='input-search-bar'
          setValue={v=>this.setState({description:v})}
          />

          <button
            onClick={(e) => {

              const obj = {
                email:this.state.email,
                description:this.state.description,
                userId:localStorage().getItem("idProfile") || null,
                typeUser:localStorage().getItem("typeProfile") || null,
                fromUrl:window.location.href,
                navigator: {
                  brands: navigator.userAgentData.brands,
                  userAgent: window.navigator.userAgent,

                  vendor: window.navigator.vendor
                },
                error: {
                  error: this.state.error.toString(),
                  info: this.state.errorInfo.componentStack

                },
                stateLog: window.newConsole?.logs || [],
                log: this.props.logs
              }
              const string = JSON.stringify(obj, null, 4)

              e.preventDefault(); e.stopPropagation();
              var element = document.createElement('a');
              element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(string));
              element.setAttribute('download', `error${new Date().toISOString().replace(/\./, "-").replace(":", "-").replace(":", "-")}.log`);

              element.style.display = 'none';
              document.body.appendChild(element);

              element.click();

              document.body.removeChild(element);
            }}
          >Descargar informe de error</button>
          {/* <details style={{ whiteSpace: 'pre-wrap' }}>
          {this.state.error.toString()}
          <pre>
       {this.state.errorInfo.componentStack}
       </pre>
          </details> */}
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
